<mat-error *ngIf="formControl.invalid && formControl.touched">{{ name }} is required</mat-error>
